import Svg from "@/Components/Svg";
import {useShareArticle} from "@/features/share-article/model/useShareArticle";

const ShareButton = ({text, isMobile}) => {
    const {share, copied} = useShareArticle(text);

    if (isMobile) {
        return <Svg id={`shareOutlinedIcon`} className={`svg--share`} onClick={share} />;
    }

    return copied
        ? <Svg id={`doneAllOutlinedIcon`} className={`svg--copiedIcon`} onClick={share} />
        : <Svg id={`copyIcon`} className={`svg--copyIcon`} onClick={share} />;
};

export default ShareButton;
